/*
 * @Author: zhangcongcong zhangcongcong@move2newidea.com
 * @Date: 2023-12-28 14:05:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-17 16:40:05
 * @FilePath: /memo-web/src/components/memos/selectTag.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useEffect, useState, useRef } from 'react'
import { Modal, Button, Input, Select } from 'antd'
import { CloseOutlined, } from '@ant-design/icons';
import style from './index.module.scss'
import * as apis from '../../api/networkDisk'
import useStore from '../../store/useStore'
import { deepCopy } from '../../util';
import { StorageModule } from "../../modules/storage";
import TaskTagPop from './taskTagPop';
import MarkDownPop from './markDownPop';
import OfficePop from './onlyoffice';

import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import ModelScreen from './modelScreen';
import MemoModal from '../../components/memos/memoModal'
import MemoHtmlModal from '../../components/memos/memoHtmlModal'
import moment from "moment";

import ImgPreview from '../../components/memos/imgPreview'

const { TextArea } = Input;
interface State {
    txtStr: any,
    imagePath: any,
    annotation: any
}
interface Props {
    visible?: any;
    onClose?: () => void;
    onRefresh?: () => void;
    onClick?: (i: any) => void;
    saveNode?: (i: any, txt: any,) => void;
    txt?: any;
    isAdd?: any;
    operationType?: any;
    change?: (i: any) => void;
    openVisible?: any
}

const SelectTag = (props: Props) => {
    const { store, dispatch } = useStore();
    const [state, setState] = useState<State>({
        txtStr: '',
        imagePath: '',
        annotation: []
    })
    const [operationName, setOperationName] = useState<any>('');
    const [txt, setTxt] = useState<any>('');
    const [userInfo, setUserInfo] = useState<any>();

    let memoId = useRef<String[]>([]);

    useEffect(() => {
        console.log('selectTag')
        setUserInfo(StorageModule.getUser().user);
        if (props.visible) {
            dispatch({
                type: 'SET_LABELPOP',
                data: true
            });
        } else {
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { content: "", data: {} }
            });
        }
    }, [props.visible])
    useEffect(() => {
        if (!store.selectTagVisible) {
            dispatch({
                type: 'SET_SELECTTAGMETA',
                data: {}
            });
            dispatch({
                type: 'SET_CNODE',
                data: null
            });
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { content: "", data: {} }
            });
            dispatch({
                type: 'SET_WATCHISMARK',
                data: true
            });
        } else {
        }
    }, [store.selectTagVisible])
    useEffect(() => {
        if (memoId.current.length == 0) {
            getId()
        }
    }, [memoId.current])
    const close = () => {
        console.log('closeSET_SELECTTAGVISIBLE')
        dispatch({
            type: 'SET_SELECTTAGVISIBLE',
            data: false
        });
        props.onClose && props.onClose()
    }
    /**
     * 保存节点
     * 可新建空白便签
     * 不可新建空白注释
     * 编辑注释如果没有内容等同于删除
     */
    const saveNode = (type: any,) => {
        let isAdd: any = store.memoOperation.isAdd
        let subjectData: any = {
            current: store.subjectInfo.data
        }
        console.log('subjectData', subjectData, store.memoNode, store.myEditMemo, store.cNode, store.relationbelongtos_superid)
        let memo: any = store.myEditMemo
        // setMemoModal(false)
        //不可新建空白注释
        console.log(`type=${type}, isAdd$=${isAdd}, txt=${txt},state.txtStr=${state.txtStr}`)
        if (type === 'comments' && isAdd && !state.txtStr) return
        if (isAdd) {
            console.log('新增')
            createNode(type)
        } else {
            console.log('修改',)
            let params: any = deepCopy(subjectData.current)
            params.$operate$ = 'save'
            let deleteArr: any = []
            //增量传值，所以将memos、comments、relationBelongTos置空
            params.memos = []
            params.comments = []
            params.relationBelongTos = []
            // //console.log(memo.data)
            params[type] = [{ ...memo.data, content: state.txtStr }]
            let isDelete = false
            if (type == 'memos') {
                console.log('params.memos', params.memos)
                params.memos[0].mimeType = null
                // params.memos[0].tagMetas = params.memos[0].tagMetas.filter((i: any) => i.type !== 'replacement')

                params.memos[0].tagMetas.map((i: any) => {
                    if (i.type == 'replacement') {
                        isDelete = true
                        console.log('1111', i)
                        delMemoNotation((i.instance) ? i.instance.id : store.memoNode.mainTagMetaId, i.notation, params, memo,)
                    }
                })
                params.memos[0].tagMetas = params.memos[0].tagMetas.filter((i: any) => i.type !== 'replacement')
                // return
            }
            if (type === 'comments' && !txt) {
                params[type][0].$operate$ = 'delete'
                deleteArr.push(params[type][0].id)
            }
            if (type == 'document') {
                console.log('document')
                delete params['document']
                params['memos'] = [{ ...memo.data, content: state.txtStr }]
            }
            // memo.setData({ ...memo.data, label: state.txtStr })
            if (!isDelete) {
                saveSubject(params, memo,)
            }
        }
    }
    const delMemoNotation = async (id: any, notation: any, params?: any, memo?: any) => {
        console.log(id)
        let res: any = await apis.delMemoNotation(id, notation,)
        if (res.ok) {
            saveSubject(params, memo,)
        }
    }
    const getId = async () => {
        try {
            let res: any = await apis.sequenceSerial()
            if (res.ok) {
                memoId.current = memoId.current.concat(res.data)
            }
        } catch (e) { }
    }
    const createNode = (type: any, $operate$?: any, id?: any) => {
        try {
            //
            let params: any = deepCopy(store.subjectInfo.data)
            let memo: any = store.myEditMemo
            //console.log('ss', params)
            params.$operate$ = 'save'

            //框选多个的情况
            let n_memoId: any = memoId.current
            console.log(memoId.current)
            if (n_memoId.length < 1) {
                //console.log('小于')
                getId()
                setTimeout(() => {
                    createNode(type, $operate$)
                }, 200)
                return
            }

            //增量传值，所以将memos、comments、relationBelongTos置空
            params.memos = []
            params.comments = []
            params.relationBelongTos = []
            console.log(userInfo?.id)
            let _memoId = (store.myEditMemo.data.hasOwnProperty('id')) ? store.myEditMemo?.data?.id : memoId.current[0]
            if (!$operate$) {
                //新建
                //console.log('新建', selectedCells.current, diskMenuShow.prop().position)
                console.log('type', type)
                if (type === 'memos' || type === 'comments') {
                    params[type] = [{
                        $operate$: 'save',
                        ownerId: userInfo?.id,
                        content: ($operate$) ? memo.data.label : state.txtStr,
                        id: _memoId,
                        visible: true,
                        x: store.mousePosition?.x || 0,
                        y: store.mousePosition?.y || 0
                    }]
                } else if (type === 'relationBelongTos') {
                    console.log('params', store.memoInfo, store.myEditMemo)
                    params.relationBelongTos = [{
                        $operate$: 'save',
                        ownerId: userInfo?.id,
                        id: _memoId,
                        visible: true,
                        superId: store.relationbelongtos_superid,
                        suborId: id,
                        content: ""
                    }]
                    console.log('relationBelongTos', params)
                } else {
                    params['memos'] = [{
                        $operate$: 'save',
                        ownerId: userInfo?.id,
                        content: store.myEditMemo.content,
                        id: _memoId,
                        visible: true,
                        x: store.mousePosition?.x || 0,
                        y: store.mousePosition?.y || 0,
                        tagMetas: store.myEditMemo.data.tagMetas
                    }]
                    console.log(params['memos'], store.myEditMemo)
                    // let _tagMetaOrg = store.tagMeta.find((i: any) => i.mimeType == type)
                    // let _tagMeta = {
                    //     mimeType: _tagMetaOrg.mimeType,
                    //     name: _tagMetaOrg.name,
                    //     notation: _tagMetaOrg.notation,
                    //     type: _tagMetaOrg.type,
                    // }
                    console.log('params', $operate$, params, state.txtStr, store.myEditMemo, store.myEditMemo.data)
                    params['memos'][0].tagMetas[0].instance.memoId = _memoId
                    if (type == 'text/markdown') {
                        params['memos'][0].tagMetas[0].instance.content = ($operate$) ? memo.data.label : state.txtStr
                    }
                    else if (type == 'image/*') {
                        delete params['memos'][0].tagMetas[0].instance.annotation
                    }
                    // else if (type == 'image/m2ni-img-notas') {
                    //     params['memos'][0].tagMetas = [{
                    //         ..._tagMeta,
                    //         instance: {
                    //             imagePath: state.imagePath,
                    //             createAt: "2023-12-29T15:40:10",
                    //             // id: memoId.current[1],
                    //             memoId: memoId.current[0],
                    //             annotation: state.annotation
                    //         },
                    //     }]
                    // }

                    // memoId.current.shift()
                }
                if (!store.myEditMemo.data.hasOwnProperty('id')) {
                    memoId.current.shift()
                }
                console.log(JSON.stringify(params))
                saveSubject(params)
                return
            }
            //memoId.current.splice(0, selectedCells.current.length + len)
            memoId.current = []
            //console.log('复制====', params)
            saveSubject(params)
        } catch (e) { console.log('error,', e) }
    }
    /**
     * 
     * @param params 保存主题
     */
    const saveSubject = async (params: any, memo?: any,) => {
        //console.log(JSON.stringify(params))
        try {

            let res: any = await apis.putExcellingTopic(params.id, params)
            if (res.ok) {
                // getDetail(subjectData.current?.id, memo)
                // memoId.current.shift()
                // setMemoId(memoId)
                dispatch({
                    type: 'SET_MEMOINFO',
                    data: { ...params }
                });
                if (store.relationbelongtos_superid) {
                    console.log('store.relationbelongtos_superid', store.relationbelongtos_superid)
                    createNode('relationBelongTos', null, params.memos[0].id)
                    dispatch({
                        type: 'SET_RELATIONBELONGTOS_SUPERID',
                        data: null
                    });
                }
                console.log('href', window.location.hash, store.memoOperation.isAdd)
                //任务看板新建便签任务
                if (window.location.hash.indexOf('#/taskKanban') > -1 && store.memoOperation.isAdd) {
                    addTask(params.memos[0].id)
                }
            }
        } catch (e) {
        }

    }
    /**
        * 新建/修改任务计划
        * @returns 
        */
    const addTask = async (id: any) => {
        try {
            let _userInfo: any = StorageModule.getUser().user
            let _params: any = {
                memoId: id,
                name: '任务计划',
            }
            _params.executorId = _userInfo?.id
            _params.finishTime = moment(new Date()).format('YYYY-MM-DDT23:59:59')
            _params.manHour = 1
            let res: any = await apis.putMemoNotation(id, 'TaskTag', _params)
            if (res.ok) {
            }

        } catch (e) {
            console.log(e)

        }
    }
    return (
        <> {store.selectTagVisible && <Modal
            centered
            onCancel={() => {
                close()
            }}
            keyboard={false}
            open={store.selectTagVisible}
            width={store.modelFullScreen ? '100%' : '800px'}
            className='HScreen'
            maskClosable={false}
            footer={null}

            title=""  >
            <>
                <>{console.log("store.memoNode", store.memoNode, store.memoModal, store.memoOperation)}</>
                {store.memoModal &&
                    <MemoModal visible={true} saveNode={(e, text) => {
                        console.log('props.operationType, text', e)
                        setTxt(text)
                        state.txtStr = text
                        setState(state);
                        saveNode(e)
                    }} isAdd={store.memoOperation.isAdd} operationType={store.memoOperation.operationType}
                        onClose={() => {
                            close()
                        }}
                    />
                }
                {store.memoHtmlVisible && <MemoHtmlModal onClose={() => {
                    close()
                }} saveNode={(e, text) => {
                    setTxt(text)
                    state.txtStr = text
                    setState(state);
                    saveNode(e)
                }} />}
                {store.markDownVisible &&
                    <MarkDownPop onClose={() => {
                        close()
                    }} saveNode={(e, text) => {
                        setTxt(text)
                        state.txtStr = text
                        setState(state);
                        saveNode(e)
                    }} />
                }
                {store.taskVisible &&
                    <TaskTagPop saveNode={(e, text) => {
                        console.log('props.operationType, text', text)
                        setTxt(text)
                        state.txtStr = text
                        // state.imagePath = text.imagePath
                        // state.annotation = text.annotation
                        setState(state);
                        saveNode(e)
                    }} onClose={() => {
                        close()
                    }} />
                }
                {store.wordVisible &&
                    <OfficePop saveNode={(e, text) => {
                        setTxt(text)
                        state.txtStr = text
                        setState(state);
                        saveNode(e)
                    }} onClose={() => {
                        close()
                    }} />
                }
            </>
        </Modal>}
        </>
    )
}

export default SelectTag